module.exports = __webpack_public_path__ + "static/media/ICT4UCover.d8f957d3.jpg";